import { Component, OnInit } from '@angular/core';
import {NavController} from '@ionic/angular';
//import { Router } from '@angular/router';
//import { GlobalVars } from '../../../../providers/globalVars';

@Component({
  selector: 'app-purchaseconfirm',
  templateUrl: './purchaseconfirm.page.html',
  styleUrls: ['./purchaseconfirm.page.scss'],
})
export class PurchaseconfirmPage implements OnInit {

  constructor(public navCtrl:NavController){}//,private router:Router,private gv:GlobalVars) { }

  ngOnInit() {
  }

  /*goprev(){
    let parent = this.router.url.substring(0, this.router.url.indexOf('/purchaseconfirm'));
    if(parent.indexOf('/pfmenu')>-1)
      this.navCtrl.navigateBack(parent + "/mypoint");
    else
      this.navCtrl.navigateForward(parent + "/pitemcheckout/" + this.gv.pre_pitemcode);
  }*/

}
